import styled from 'styled-components';
import { colors, fontFamily, functions, zIndex } from '../../ui/variables';

export const LoadingSectionStyle = styled.div`
  @keyframes rotate {
    0% {
      transform: rotate(0);
    }
    50% {
      transform: rotate(-180deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }

  position: relative;
  align-items: center;
  background-color: ${functions.rgba(colors.white, 0.8)};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  height: 100%;

  .loading-message-container {
    .loading-image-wrapper {
      margin: 45px 45px 0px 45px;
      width: 130px;
      svg {
        animation: rotate 800ms infinite linear;
        display: block;
        fill: ${colors.softBlue};
        height: auto;
        width: 100%;
      }
    }

    .loading-message-wrapper {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.softBlue};
      font-size: 14px;
      line-height: 18px;
      margin: 32px auto 0;
      max-width: 220px;
      padding: 16px;
      text-align: center;
      width: 100%;
    }
  }
`;
